<template>
  <b-modal id="filters-modal" ref="filtersModal" title="Counselor Filters">
    <filters 
      :value="filters" 
      @input="val => filters = val"
    />
    <template slot="modal-footer">
      <button class="btn" type="button" @click="cancel()">Cancel</button>
      <button class="btn btn--primary" type="button" @click="filter()" >Filter</button>
    </template>
  </b-modal>
</template>

<script>
import Filters from './filters/Filters.vue';
import FiltersModel from './filters/FiltersModel';

export default {
  name: 'ModalFilters',

  components: {
    Filters,
  },

  props: {
    value: {
      type: Object,
      default: () => new FiltersModel(),
      require: true
    }
  },

  data() {
    return {
      filters: new FiltersModel()
    }
  },

  watch: {
    value() {
      this.filters = new FiltersModel(this.value);
    }
  },

  methods: {
    show() {
      this.$refs.filtersModal.show();
    },

    cancel() {
      this.filters = new FiltersModel(this.value);
      this.$refs.filtersModal.hide();
    },

    filter() {
      this.$emit('input', this.filters);
      this.filters = null;
      this.$refs.filtersModal.hide();
    }
  },
};
</script>

<style></style>
